export default __webpack_public_path__ + "c19c27451d1eee89cf28b58363206d67.png";